import { Component, Inject, Input } from '@angular/core'
import { Profile } from '../../../models/users.interface'
import { GroupService } from '../../../services/group/group.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Group } from '../../../models/group.interface'
import { AngularDualListBoxModule } from 'angular-dual-listbox'
import { MatIcon } from '@angular/material/icon'
import { dualListSettings } from '../../../../main'

@Component({
    selector: 'app-group-select',
    standalone: true,
    imports: [AngularDualListBoxModule, MatIcon],
    templateUrl: './group-select.component.html',
    styleUrl: './group-select.component.css',
})
export class GroupSelectComponent {
    groups: Group[] = []
    selected: Group[] = []
    profile: Profile | null = null
    format = dualListSettings
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0

    constructor(
        private groupService: GroupService,
        // private sweetAlert: AlertService,
        private dialogRef: MatDialogRef<GroupSelectComponent>,
        @Inject(MAT_DIALOG_DATA) data: { profile: Profile | null }
    ) {
        this.profile = data.profile
    }

    ngOnInit(): void {
        this.fetchGroups()
        if (this.profile) {
            this.selected = [...(this.profile.role_group ?? [])]
        }
    }

    closeDialog() {
        this.dialogRef.close()
    }

    fetchGroups() {
        this.groupService
            .getGrupos()
            .subscribe((groups) => (this.groups = groups))
    }

    onSubmit() {
        if (this.selected.length > 0 && this.profile) {
            const payload = {
                profile: this.profile,
                groups: this.selected,
            }
            this.groupService.assignGroup(payload).subscribe(() => {
                this.closeDialog()
                const msg = `El grupo fue asignado <b>CORRECTAMENTE!</b>`
                //   this.sweetAlert.showAlert(msg);
            })
        }
    }
}
